import type { Components, Theme } from '@mui/material/styles';

export const MuiBadge: Components<Theme>['MuiBadge'] = {
  defaultProps: { color: 'error', variant: 'dot' },
};
